import * as THREE from "three";

export const getRotationFromMatrix = (m:THREE.Matrix4) => {
	const pos = new THREE.Vector3();
	const rot = new THREE.Quaternion();
	rot.setFromRotationMatrix(m);
	const v = new THREE.Euler().setFromQuaternion(rot).toVector3();
	return new THREE.Vector3(v.x * THREE.MathUtils.RAD2DEG, v.y * THREE.MathUtils.RAD2DEG, v.z * THREE.MathUtils.RAD2DEG);
}